import React from 'react';
import cx from 'classnames';

import useLocationFrom from '@/hooks/useLocationFrom';
import BackIcon from '@/assets/imgs/back.svg?react';

import styles from './index.module.less';

interface IProps {
  backUrl?: string;
  className?: string;
  text?: any
  onClick?: () => void;
}

/** 返回 */
const Back: React.FC<IProps> = (props) => {
  const { backUrl, className, text = '返回', onClick } = props;
  const { navigateBack } = useLocationFrom();

  return (
    <div className={cx(styles['back'], className)}>
      <div
        className={styles['back_header']}
        onClick={() => {
          if (onClick) {
            onClick();
            return;
          }
          navigateBack(backUrl);
        }}
      >
        <BackIcon />
        <span className={styles['back_header_title']}>{text}</span>
      </div>
    </div>
  );
};

export default Back;
